import React from 'react'
import '../Brand.css'
import BrandPrinterSetup from '../BrandPrinterSetup'
const HpSearch = () => {
  return (
    <>
    
   <BrandPrinterSetup 
        brand="HP" 
        image="https://support-printers.netlify.app/img/HP_logo_630x630.png" 
      />
    </>
  )
}

export default HpSearch
